export default function speedDial({ variables, }) {
    return {
        MuiSpeedDial: {
            styleOverrides: {
                fab: {
                    boxShadow: variables.box_shadow_small,
                },
            },
        },
        MuiSpeedDialAction: {
            styleOverrides: {
                fab: {
                    backgroundColor: variables.surface,
                    color: variables.text_medium,
                    border: `1px solid ${variables.border_subtle}`,
                    boxShadow: variables.box_shadow_small,
                    "&:hover": {
                        backgroundColor: variables.surface_hover,
                    },
                },
                staticTooltipLabel: {
                    fontSize: variables.type_body_xs_font_size,
                    whiteSpace: "nowrap",
                    border: `1px solid ${variables.border_subtle}`,
                    borderRadius: variables.border_radius_small,
                    backgroundColor: variables.surface,
                    color: variables.text_primary,
                },
            },
        },
    };
}
//# sourceMappingURL=speedDial.js.map